module.exports = __webpack_public_path__ + "static/media/wolf-modal.5ea193a6.gif";